import { CreateToolbar, MapToolType } from "../createToolbar";

export class ToolbarMeasureHandler {
    constructor(private toolbar: CreateToolbar) {}

    handle = (idElement: string, containerId: string) => {
        const listBtnToggle = [
            `ruler-tool-${containerId}`,
            `measure-ruler-${containerId}`,
            `measure-multi-ruler-${containerId}`,
            `eraser-measure-ruler-${containerId}`,
            `eye-show-dim-${containerId}`,
            `eye-hide-dim-${containerId}`,
            `remove-all-dim-${containerId}`,
            `done-dim-${containerId}`
        ];

        const listIdGroup = [
            `dim-group-${containerId}`,
            `point-group-${containerId}`,
            `label-properties-${containerId}`,
            `group-data-${containerId}`,
            `data-element-${containerId}`,
            `group-camera-${containerId}`,
            `fly-camera-${containerId}`
        ];
        const btnActiveGr = listBtnToggle.slice(1, listBtnToggle.length - 2);

        this.toolbar._unActiveBtnInGroup(listBtnToggle);
        this.toolbar._activeBtnInGroup(btnActiveGr, idElement);

        switch (idElement) {
            case `ruler-tool-${containerId}`:
                this.toolbar.deactivateOtherTools(MapToolType.MEASURE);
                this.toolbar._showHideElementsByID(listIdGroup, false);
                this.toolbar._showHideElementByID(`dim-group-${containerId}`, true);
                this.toolbar._showHideElementsByID(listBtnToggle, true);
                this.toolbar._showHideElementByID(`ruler-tool-${containerId}`, false);

                this.toolbar._showHideElementByID(`group-camera-${containerId}`, false);
                this.toolbar._showHideElementByID(`group-data-${containerId}`, false);
                this.toolbar._showHideElementByID(`group-note-${containerId}`, false);

                this.toolbar._activeBtn(`measure-ruler-${containerId}`, true);
                this.toolbar._measure!.showHideAllDimensionCesium(true);
                this.toolbar._measure!.dimensionCesium();
                this.toolbar._contextMenu!.destroyContextMenu();
                break;

            case `measure-ruler-${containerId}`:
                this.toolbar._measure!.showHideAllDimensionCesium(true);
                this.toolbar._measure!.isMultiDim = false;
                this.toolbar._measure!.dimensionCesium();
                break;
            case `measure-multi-ruler-${containerId}`:
                this.toolbar._measure!.isMultiDim = true;
                this.toolbar._measure!.showHideAllDimensionCesium(true);
                this.toolbar._measure!.dimensionCesium();
                break;
            case `eraser-measure-ruler-${containerId}`:
                this.toolbar._measure!.showHideAllDimensionCesium(true);
                this.toolbar._measure!.removeDimCesium();
                break;
            case `eye-show-dim-${containerId}`:
                this.toolbar._measure!.showHideAllDimensionCesium(true);
                break;
            case `eye-hide-dim-${containerId}`:
                this.toolbar._measure!.showHideAllDimensionCesium(false);
                break;
            case `remove-all-dim-${containerId}`:
                this.toolbar._measure!.removeAllDimensionCesium();
                break;
            case `done-dim-${containerId}`:
                this.toolbar._measure!.refreshAllAction();
                this.toolbar._measure!.showHideAllDimensionCesium(false);
                this.toolbar._unActiveBtnInGroup(listBtnToggle);
                if (this.toolbar._activeBtnClippingPlane) {
                    const filteredList = listIdGroup.filter(id => ![`group-data-${containerId}`, `data-element-${containerId}`, `group-camera-${containerId}`, `fly-camera-${containerId}`].includes(id));
                    this.toolbar._showHideElementsByID(filteredList, true);
                } else {
                    this.toolbar._showHideElementsByID(listIdGroup, true);
                }
                this.toolbar._showHideElementsByID(listBtnToggle, false);
                this.toolbar._showHideElementByID(`ruler-tool-${containerId}`, true);
                
                if (!this.toolbar._activeBtnClippingPlane) {
                    this.toolbar._showHideElementByID(`group-camera-${containerId}`, true);
                    this.toolbar._showHideElementByID(`group-data-${containerId}`, true);
                }
                this.toolbar._showHideElementByID(`group-note-${containerId}`, true);
                
                if (!this.toolbar._activeBtnClippingPlane) {
                    this.toolbar._contextMenu!.createContextMenu();
                }
                break;
            default:
                break;
        }
    };
}
